import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { FortuneWheelProfile } from "../../../entities/wheelGame_v2";
import { getWheelProfile, patchWheelProfile, postWheelProfile } from "./thunks";

interface FortuneWheelProfileState {
  loading: boolean,
  saveLoading: boolean,
  profile?: FortuneWheelProfile,
}

const initialState: FortuneWheelProfileState = {
  loading: false,
  saveLoading: false,
}

const saveFortuneWheel = (
  builder: ActionReducerMapBuilder<FortuneWheelProfileState>,
  action: any
) => {
  builder.addCase(action.pending, (state: FortuneWheelProfileState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: FortuneWheelProfileState, action: PayloadAction<FortuneWheelProfile>) => {
    state.saveLoading = false;
    state.profile = action.payload;
  });
  builder.addCase(action.rejected, (state: FortuneWheelProfileState) => {
    state.saveLoading = false;
  });
};

export const fortuneWheelProfileStore = createSlice({
  name: "fortuneWheelProfile",
  initialState: initialState,
  reducers: {
    clearProfile: (state) => {
      state.profile = undefined;
    }
  },
  extraReducers: (builder) => {
    // getWheelProfile
    builder.addCase(getWheelProfile.pending, state => {
      state.loading = true;
    })
    builder.addCase(getWheelProfile.fulfilled, (state, action) => {
      state.profile = action.payload;

      state.loading = false;
    })
    const saveActions = [postWheelProfile,
      patchWheelProfile];

    saveActions.forEach((action) => { saveFortuneWheel(builder, action) })
  },
})

export const { clearProfile } = fortuneWheelProfileStore.actions

export default fortuneWheelProfileStore.reducer;